import { ForwardedRef, ForwardRefExoticComponent, useMemo, useState } from 'react'

import { IInputProps } from '../inputs'

import { IValidateInputProps } from './models/IValidateInputProps'
import { ValidationStatus } from './models/IValidationStatus'
import { Validator } from './Validator'

interface IValidateInputWrapper extends IValidateInputProps {
  InputComponent: ForwardRefExoticComponent<IInputProps>
  value: string
  inputRef?: ForwardedRef<HTMLInputElement>
}

export const ValidateInputWrapper = (props: IValidateInputWrapper) => {
  const { inputRef, InputComponent } = props
  const [validateStatus, setValidateStatus] = useState<ValidationStatus>(ValidationStatus.Valid)
  const valueDependencies = useMemo(() => {
    if (props.valueDependencies) {
      return props.valueDependencies
    }
    return [props.disabled]
  }, [props.disabled, props.valueDependencies])

  return (
    <Validator
      classes={props.classes?.validatorClasses}
      value={props.validatorValue || props.value}
      valueDependencies={valueDependencies}
      field={props.field}
      throttle={props.throttle}
      tooltipVisible={props.tooltipVisible}
      checkFn={props.disabled ? null : props.checkFn}
      onChangeValidation={(status) => {
        setValidateStatus(status)
      }}
    >
      <InputComponent
        {...props}
        classes={props.classes?.inputClasses}
        inputRef={inputRef}
        wrapper={
          props.value === props.defaultValue && validateStatus === ValidationStatus.Invalid
            ? 'warning'
            : validateStatus === ValidationStatus.Invalid
              ? 'danger'
              : 'normal'
        }
      />
    </Validator>
  )
}
